import type { FC } from "react";
import { IconBaseProps } from "react-icons";
import { PiPlaceholder } from "react-icons/pi";
import * as Icons from "./export"; 

export type IconType = keyof typeof Icons | "placeholder";

interface RenderIconProps extends IconBaseProps {
  type: IconType | string;
  color?: string; 
}

export const RenderIcon: FC<RenderIconProps> = ({ type,  ...props }) => {
  if (type === "placeholder") return <PiPlaceholder {...props} />;

  const IconComponent = Icons[type]; 
  return IconComponent ? (
    <IconComponent {...props}  />
  ) : (
    <PiPlaceholder {...props} />
  );
};
